import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { ManagedKpi } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/**
 * Archive a KPI (`POST /v1/kpis/:id/archive`) — retire, never hard-delete.
 * Refreshes lists (lifecycle badge) and the detail.
 */
export function useArchiveKpi() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpi, Error, string>({
    mutationFn: (kpiId) => kpiApi.archive(config, kpiId),
    onSuccess: (_data, kpiId) => {
      void qc.invalidateQueries({ queryKey: kpiKeys.lists() });
      void qc.invalidateQueries({ queryKey: kpiKeys.detail(kpiId) });
    },
  });
}
